import { connect } from 'react-redux';

import { getDocumentById, getOverlayById } from 'src/selectors/layers';
import { DOCUMENT, BACKGROUND, OVERLAY, LayerType } from 'src/pages/editor/components/layer/layerTypes';
import {
    changeEngravingColor,
    ENGRAVING_COLOR,
    setColorProfile,
    PROFILE_COLORS,
    setEffect,
    changeLetterPressMode,
    changeLetterPressDepth,
} from '../../documents/slice';
import advancedView from './view';
import { RootState } from 'src/store/storeManager.js';
import type { Document as SceneDocType } from 'src/pages/editor/components/documents/slice';

function getLayerFromStore(state: RootState, id: string, type: LayerType) {
    switch (type) {
        case OVERLAY:
            return getOverlayById(state, id);
        case DOCUMENT:
        default:
            return getDocumentById(state, id);
    }
}

const mapStateToProps = (state: RootState, ownProps: { id: string; type: LayerType }) => {
    const { id, type } = ownProps;
    let isEngraving: boolean = false;
    let colorEngraving = ENGRAVING_COLOR;
    let colorProfile = PROFILE_COLORS[0].value;
    let letterPress: { mode: string; depth: number } | undefined;

    if (id && type && type !== BACKGROUND) {
        const layer = getLayerFromStore(state, id, type);
        if (layer) {
            isEngraving = (layer as SceneDocType).isEngraving || false;
            colorEngraving = (layer as SceneDocType).engravingColor || ENGRAVING_COLOR;
            colorProfile = (layer as SceneDocType).colorProfile || PROFILE_COLORS[0].value;
            letterPress = (layer as SceneDocType).letterPress;
        }
    }

    return {
        isEngraving,
        colorEngraving,
        colorProfile,
        profileColors: PROFILE_COLORS,
        letterPress,
    };
};

const advancedContainer = connect(mapStateToProps, {
    changeEngravingColor,
    changeProfileColor: setColorProfile,
    setEffect,
    changeLetterPressMode,
    changeLetterPressDepth,
})(advancedView);

export default advancedContainer;
